import { useFormContext } from 'react-hook-form';
import { z } from 'zod';

export const ItemSetQuestionChangeSchema = z.object({
  questionGroupId: z.string(),
});

export type ItemSetQuestionChangeFormInput = z.infer<typeof ItemSetQuestionChangeSchema>;

export const useItemSetQuestionChangeForm = useFormContext<ItemSetQuestionChangeFormInput>;
